module.exports = __webpack_public_path__ + "static/media/shadow-attack-3.0aa5dc41.png";